// The University of Central Florida's undergraduate majors (#2652). Read
// on 2026-10-01 from the official 2026-2027 Undergraduate Catalog (UCF's
// Kuali catalog at ucf.edu/catalog/undergraduate, the program list its page
// loads), every program the catalog types "Major", grouped by the college
// it names. The catalog lists many majors once per track ("Biology (B.S.),
// Marine and Aquatic Biology Track"); tracks are folded into their major,
// one line per degree, so "Sociology (B.A./ B.S.)" becomes two lines.
// Left out: minors, certificates, accelerated bachelor's-to-master's
// programs, articulated A.S. programs, and three tracks for students who
// already hold a degree or license (the Accelerated Second Degree BSN, the
// RN to BSN and the A.S. to B.S. Lodging and Restaurant Management track).
// Degree abbreviations are the catalog's own. The KB's majors list was the
// starting point; the catalog wins.
const majors = {
    "slug": "university-of-central-florida",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in UCF's official 2026-2027 Undergraduate Catalog, grouped by the college that offers it, with the degree it leads to. Tracks are folded into their major; minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Barry S. Miller College of Business",
            "source": {
                "label": "UCF 2026-2027 Undergraduate Catalog, Programs",
                "url": "https://www.ucf.edu/catalog/undergraduate/#/programs"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Business Economics",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Finance",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Integrated Business",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Management",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Marketing",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Real Estate",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Risk Management and Insurance",
                    "degree": "B.S.B.A."
                }
            ]
        },
        {
            "name": "College of Arts and Humanities",
            "source": {
                "label": "UCF 2026-2027 Undergraduate Catalog, Programs",
                "url": "https://www.ucf.edu/catalog/undergraduate/#/programs"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "B.Des."
                },
                {
                    "name": "Art",
                    "degree": "B.A."
                },
                {
                    "name": "Emerging Media",
                    "degree": "B.F.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Humanities and Cultural Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Integrated Humanities",
                    "degree": "B.A."
                },
                {
                    "name": "Integrated Humanities",
                    "degree": "B.S."
                },
                {
                    "name": "Latin American, Caribbean, and Latinx Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.M."
                },
                {
                    "name": "Music Education",
                    "degree": "B.M.E."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Photography",
                    "degree": "B.S."
                },
                {
                    "name": "Religion and Cultural Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Studio Art",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.F.A."
                },
                {
                    "name": "Writing and Rhetoric",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Community Innovation and Education",
            "source": {
                "label": "UCF 2026-2027 Undergraduate Catalog, Programs",
                "url": "https://www.ucf.edu/catalog/undergraduate/#/programs"
            },
            "majors": [
                {
                    "name": "Career and Technical Education",
                    "degree": "B.S."
                },
                {
                    "name": "Criminal Justice",
                    "degree": "B.A."
                },
                {
                    "name": "Criminal Justice",
                    "degree": "B.S."
                },
                {
                    "name": "Early Childhood Development and Education",
                    "degree": "B.S."
                },
                {
                    "name": "Elementary Education",
                    "degree": "B.S."
                },
                {
                    "name": "Emergency Management",
                    "degree": "B.A."
                },
                {
                    "name": "Emergency Management",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Science",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Exceptional Student Education",
                    "degree": "B.S."
                },
                {
                    "name": "Integrative General Studies",
                    "degree": "B.G.S."
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Leadership",
                    "degree": "B.A."
                },
                {
                    "name": "Leadership",
                    "degree": "B.S."
                },
                {
                    "name": "Legal Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Legal Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Nonprofit Management",
                    "degree": "B.A."
                },
                {
                    "name": "Nonprofit Management",
                    "degree": "B.S."
                },
                {
                    "name": "Public Administration",
                    "degree": "B.A."
                },
                {
                    "name": "Public Administration",
                    "degree": "B.S."
                },
                {
                    "name": "Secondary Education",
                    "degree": "B.S."
                },
                {
                    "name": "Sustainability",
                    "degree": "B.A."
                },
                {
                    "name": "Sustainability",
                    "degree": "B.S."
                },
                {
                    "name": "Teacher Education",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Engineering and Computer Science",
            "source": {
                "label": "UCF 2026-2027 Undergraduate Catalog, Programs",
                "url": "https://www.ucf.edu/catalog/undergraduate/#/programs"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "B.S.A.E."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S.C.E."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S.Cp.E."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Construction Engineering",
                    "degree": "B.S.Con.E."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S.E.E."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "B.S.Env.E."
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "B.S.I.E."
                },
                {
                    "name": "Information Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "B.S.M.S.E."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S.M.E."
                }
            ]
        },
        {
            "name": "College of Health Professions and Sciences",
            "source": {
                "label": "UCF 2026-2027 Undergraduate Catalog, Programs",
                "url": "https://www.ucf.edu/catalog/undergraduate/#/programs"
            },
            "majors": [
                {
                    "name": "Communication Sciences and Disorders",
                    "degree": "B.S."
                },
                {
                    "name": "General Health Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Health Informatics",
                    "degree": "B.S."
                },
                {
                    "name": "Health Information Management",
                    "degree": "B.S."
                },
                {
                    "name": "Health Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Health Services Administration",
                    "degree": "B.S."
                },
                {
                    "name": "Kinesiology",
                    "degree": "B.S."
                },
                {
                    "name": "Social Work",
                    "degree": "B.S.W."
                }
            ]
        },
        {
            "name": "College of Medicine",
            "source": {
                "label": "UCF 2026-2027 Undergraduate Catalog, Programs",
                "url": "https://www.ucf.edu/catalog/undergraduate/#/programs"
            },
            "majors": [
                {
                    "name": "Biomedical Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Biotechnology",
                    "degree": "B.S."
                },
                {
                    "name": "Medical Laboratory Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Molecular Microbiology",
                    "degree": "B.S."
                },
                {
                    "name": "Molecular and Cellular Biology",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "UCF 2026-2027 Undergraduate Catalog, Programs",
                "url": "https://www.ucf.edu/catalog/undergraduate/#/programs"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "B.S.N."
                }
            ]
        },
        {
            "name": "College of Optics and Photonics",
            "source": {
                "label": "UCF 2026-2027 Undergraduate Catalog, Programs",
                "url": "https://www.ucf.edu/catalog/undergraduate/#/programs"
            },
            "majors": [
                {
                    "name": "Photonic Science and Engineering",
                    "degree": "B.S.P.S.E."
                }
            ]
        },
        {
            "name": "College of Sciences",
            "source": {
                "label": "UCF 2026-2027 Undergraduate Catalog, Programs",
                "url": "https://www.ucf.edu/catalog/undergraduate/#/programs"
            },
            "majors": [
                {
                    "name": "Actuarial Science",
                    "degree": "B.S."
                },
                {
                    "name": "Advertising/Public Relations",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Communication",
                    "degree": "B.A."
                },
                {
                    "name": "Communication and Conflict",
                    "degree": "B.A."
                },
                {
                    "name": "Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Digital Media",
                    "degree": "B.A."
                },
                {
                    "name": "Film",
                    "degree": "B.A."
                },
                {
                    "name": "Film",
                    "degree": "B.F.A."
                },
                {
                    "name": "Forensic Science",
                    "degree": "B.S."
                },
                {
                    "name": "Integrated Sciences and Technology",
                    "degree": "B.S."
                },
                {
                    "name": "International and Global Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Journalism",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Media Production and Management",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Social Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.S."
                },
                {
                    "name": "Statistics",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Rosen College of Hospitality Management",
            "source": {
                "label": "UCF 2026-2027 Undergraduate Catalog, Programs",
                "url": "https://www.ucf.edu/catalog/undergraduate/#/programs"
            },
            "majors": [
                {
                    "name": "Entertainment Management",
                    "degree": "B.S."
                },
                {
                    "name": "Event Management",
                    "degree": "B.S."
                },
                {
                    "name": "Hospitality Management",
                    "degree": "B.S."
                },
                {
                    "name": "Lifestyle Community Management",
                    "degree": "B.S."
                },
                {
                    "name": "Lodging and Restaurant Management",
                    "degree": "B.S."
                },
                {
                    "name": "Theme Park and Attraction Management",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
